module.exports = __webpack_public_path__ + "img/EducationalJoiningApplications.76bfbce1.svg";